import React from "react"

const addLeadingZero = number => number < 10 ? `0${number}` : number

export default class DateSelectControl extends React.PureComponent {
  constructor(...args) {
    super(...args)
    const { value, initialYear = 1980, initialMonth = null, initialDay = null } = this.props
    const [year, month, day] = value ? value.split("-").map(v => +v) : [initialYear, initialMonth, initialDay]
    this.state = { day, month, year }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value) {
      const { initialYear = 1980, initialMonth = null, initialDay = null } = nextProps
      const [year, month, day] = nextProps.value ? nextProps.value.split("-").map(v => +v) : [initialYear, initialMonth, initialDay]
      this.setState({ day, month, year })
    }
  }

  handleChange({ day, month, year }) {
    const { onChange } = this.props
    this.setState({ day, month, year })
    if (day && month && year) {
      onChange(moment({ day: day, month: month-1, year }).format(moment.RUBY_DATE_FORMAT))
    } else {
      onChange(null)
    }
  }

  render() {
    const { id, name } = this.props
    const { year, month, day } = this.state

    return (
      <span>
        <select
          id={id}
          name={name}
          className="form-control form-control-inline attr-birth_date_day"
          value={day || ""}
          onChange={event => this.handleChange({ day: +event.target.value, month, year })}
        >
          <option value={null}>{I18n.t("base.date.day")}</option>
          {__range__(1, 31, true).map((j) =>
            <option key={j} value={j}>{j}</option>
          )}
        </select>
        &nbsp;
        <select
          className="form-control form-control-inline attr-birth_date_month"
          value={month || ""}
          onChange={event => this.handleChange({ day, month: +event.target.value, year })}
        >
          <option value={null}>{I18n.t("base.date.month")}</option>
          {__range__(1, 12, true).map((j) =>
            <option key={j} value={j}>{moment().set('month', j-1).format('MMMM')}</option>
          )}
        </select>
        &nbsp;
        <select
          className="form-control form-control-inline attr-birth_date_year"
          value={year || ""}
          onChange={event => this.handleChange({ day, month, year: +event.target.value })}
        >
          <option value={null}>{I18n.t("base.date.year")}</option>
          {__range__(1900, moment().year(), true).map((j) =>
            <option key={j} value={j}>{j}</option>
          )}
        </select>
      </span>
    )
  }
}



// WEBPACK FOOTER //
// ./app/webpack/frontend/components/DateSelectControl.jsx